import React from 'react'

const CategoryContent = ({containerObject}) => {
  return (
    <>
         <p>CategoryContent</p>
        {containerObject && containerObject.targeterResult ? <div dangerouslySetInnerHTML={{ __html: containerObject.targeterResult }}  ></div> : ""}

    </>
  )
}

export default CategoryContent